import React from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import Button from "@/ui/Button/Button";
import BkImg from "@/assets/bk.png";
import classNames from "classnames";
import { useReferalProgramsDataContext } from "@/store/ReferalProgramsProvider";
import { useUserInfoStore } from "@/store/userInfoStore";
import {
  activeReferalProgramsThisDay,
  maxAmountRefProgramByCategory,
  serviceTypeToUtm,
} from "@/utils/helpers";
import cls from "./styles.module.scss";

interface RegistrationScreenProps {
  isOpen: boolean;
}

const modalVariants = {
  hidden: {
    y: "100%",
  },
  visible: {
    y: "0",
    transition: { type: "spring", stiffness: 300, damping: 40 },
  },
  exit: {
    y: "100%",
    transition: { duration: 0.3 },
  },
};

const items = [
  "Подключись в парк и получи свою реферальную ссылку",
  "Отправь её другу, он подключится и будет выполнять заказы",
  "Ты получишь деньги за друга",
];

export const RegistrationScreen = ({ isOpen }: RegistrationScreenProps) => {
  const serviceType = useUserInfoStore((s) => s.serviceType);

  const { referalPrograms } = useReferalProgramsDataContext();
  const filteredReferalPrograms = activeReferalProgramsThisDay(referalPrograms);
  const maxAmount = maxAmountRefProgramByCategory(
    filteredReferalPrograms,
    "eats"
  );

  const edaBotStartParam = serviceType ? serviceTypeToUtm[serviceType] : "";

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={cls.registrationScreen}
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div className={cls.imgBlock}>
            <img src={BkImg} alt="BkImg" />
          </div>

          <FlexColumn>
            <Typography className={cls.title}>
              Приглашай друзей — <span>получай деньги</span>
            </Typography>
            <Typography className={cls.desc}>
              Подключись к реферальной программе
              <br />
              Богатого Курьера в пару кликов
            </Typography>
          </FlexColumn>

          <FlexColumn gap={10}>
            {items.map((item, index) => (
              <FlexRow key={index} gap={12} className={cls.item}>
                <div
                  className={classNames(
                    cls.number,
                    index === 2 ? cls.greenNumber : undefined
                  )}
                >
                  {index + 1}
                </div>
                <Typography>{item}</Typography>
              </FlexRow>
            ))}
          </FlexColumn>

          <FlexColumn gap={6} className={cls.earningsBlock}>
            <Typography className={cls.earningsTitle}>
              Потенциальный доход
            </Typography>
            <Typography className={cls.earningsSum}>
              до {maxAmount.toLocaleString("ru-RU")} ₽
            </Typography>
            <Typography className={cls.earningsDesc}>
              за каждого приглашённого друга
            </Typography>
          </FlexColumn>

          <Button
            trigger="ref.registration.open_bot"
            label="Получить ссылку"
            onClick={() =>
              window.open(
                `https://t.me/BK_EdaBot?start=${edaBotStartParam}`,
                "_blank"
              )
            }
            animation
          />
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};
